<template>
    <QuestionBaseQuiz :question="question">
        <div>
            <div class="">
                <div class="m-4 p-2 rounded" :class="answer === 'TRUE' ? 'bg-indigo-50' : 'bg-gray-50'">
                    <label class="">
                        <input
                            type="radio"
                            :name="`question_${question.question_id}`"
                            v-model="answer"
                            value="TRUE"
                            class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                            @keypress.enter.prevent
                        />
                        <span class="pl-1">
                            {{ question.options.yes_true_text }}
                        </span>
                    </label>
                </div>

                <div class="m-4 p-2 rounded" :class="answer === 'FALSE' ? 'bg-indigo-50' : 'bg-gray-50'">
                    <label class="">
                        <input
                            type="radio"
                            :name="`question_${question.question_id}`"
                            v-model="answer"
                            value="FALSE"
                            class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                            @keypress.enter.prevent
                        />
                        <span class="pl-1">
                            {{ question.options.no_false_text }}
                        </span>
                    </label>
                </div>
            </div>

            <div>
                <button @click="answer = null" :class="{ invisible: !answer }" class="text-gray-600" type="button">
                    <svg
                        class="w-6 h-6 inline-block"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                        ></path>
                    </svg>
                    {{ $t('messages.delete_answer') }}
                </button>
            </div>
        </div>
    </QuestionBaseQuiz>
</template>

<script>
import QuestionBaseQuiz from '@/components/Quiz/QuestionBaseQuiz.vue';

export default {
    components: { QuestionBaseQuiz },
    emits: ['update:modelValue'],
    name: 'QuestionTrueFalseQuiz',

    props: {
        question: {
            required: true,
        },
        modelValue: {
            required: true,
        },
    },

    data() {
        return {
            answer: this.modelValue,
        };
    },

    watch: {
        answer(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
};
</script>
